import styled from 'vue-styled-components';

import { GRAY, FLEX_CENTER, square } from '@/styles/common.styled';
import { FLEX_COLUMN_DIV } from '@/styles/common.styled.component';

export const ComponentWrapper = styled(FLEX_COLUMN_DIV)`
    justify-content: space-between;
    align-items: center;
    padding: 11px 16px;
    border: 1px solid ${GRAY(20)};
    border-radius: 2px;
    background-color: ${GRAY(10)};

    .top-wrapper {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .title {
            ${FLEX_CENTER}
            padding: 0;
            margin: 0;

            svg.blend-icon {
                ${square(16)}
                margin-right: 8px;
            }

            svg.info-line-icon {
                ${square(24)}
            }

            h3 {
                flex: 1;
                color: ${GRAY(100)};
                font-size: 14px;
                font-weight: 500;
                margin-right: 6px;
            }
        }
    }
`;

export const DialogContent = styled.div`
    width: 368px;
`;
export const DialogTitle = styled.div`
    font-size: 16px;
    font-weight: 500;
    color: #1c232b;
    letter-spacing: -0.01em;
`;
export const DialogDesc = styled.div`
    font-size: 15px;
    font-weight: 400;
    color: #4f5861;
    padding: 6px 0 16px;
    white-space: pre-line;
    letter-spacing: -0.01em;
`;
